module.exports = __webpack_public_path__ + "d2eaceab3808e195f09abc827c653445.svg";